<template>
    <div class="about-social-civil" v-if="pageSetup != null" id="civil-corp">
        <div class="container">
            <div class="social-head">
                <div class="column-container">
                    <div class="col-left" v-if="!isMobileChecker">
                        <div class="col-img"><img :src="pageSetup.about_social_civil.civil.img" alt=""></div>
                    </div>
                    <div class="col-right">
                        <h3>{{ pageSetup.about_social_civil.civil.title }}</h3>
                        <p v-html="pageSetup.about_social_civil.civil.desc_title"></p>
                        <div class="col-img col-img-mobile" v-if="isMobileChecker"><img :src="pageSetup.about_social_civil.civil.img" alt=""></div>
                        <div class="unique-desc">
                            <img :src="pageSetup.about_social_civil.civil.icon" alt="">
                            <strong v-html="pageSetup.about_social_civil.civil.desc_red"></strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="social-civil-list">
                <h2>{{ pageSetup.about_social_civil.civil.title_list }}</h2>
                <div class="civil-list-items">
                    <ul>
                        <li v-for="item in pageSetup.about_social_civil.civil.check_list.slice(0, 4)">
                            <img src="https://bcn.kz/cms/media/about_icon_04.svg" alt="">
                            <p v-html="item.desc"></p>
                        </li>
                    </ul>
                    <ul>
                        <li v-for="item in pageSetup.about_social_civil.civil.check_list.slice(4, 8)">
                            <img src="https://bcn.kz/cms/media/about_icon_04.svg" alt="">
                            <p v-html="item.desc"></p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="social-civil-desc">
                <div class="desc-title">
                    <img :src="pageSetup.about_social_civil.civil.check_title.icon" alt="">
                    <h3 v-html="pageSetup.about_social_civil.civil.check_title.title"></h3>
                </div>
                <div class="desc-col" v-html="pageSetup.about_social_civil.civil.desc_right"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-social-civil-section',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-social-civil.scss';
    @import '@/styles/components/about-page/respond/about-social-civil-respond.scss';
</style>